<template>
    <div class= 'l-modal__bg' v-if="loading"></div>

  <div class="signup">
    <div
          v-show="loading"
          class='loading'
        >
          <img src="../assets/loading.gif" />
        </div>
    <Form
      class="form"
      :validationSchema="validationSchema"
      v-slot="{ meta: { valid } }"
      v-if="!updated"
    >
      <div  style="padding-bottom: 300px;">
        <div class="pt-15">
          <label>ニックネーム</label>
          <div class="text-area">
            <Field
              type="text"
              v-model="nickname"
              name="nickname"
              placeholder="ニックネーム"
              class="text-field"
              @focus="focus"
              @blur="blur"
              :disabled="loading"
              tabindex="1"
            />
            <div>
              <ErrorMessage name="nickname" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>
        <div style="padding-top: 16px">
          <label>名前</label>
          <div class="name-area">
            <Field
              type="text"
              v-model="lastName"
              name="lastName"
              placeholder="山田"
              class="name-text-field"
              :disabled="loading"
              @focus="focus"
              @blur="blur"
              tabindex="2"
            />
            <Field
              type="text"
              v-model="firstName"
              name="firstName"
              placeholder="太郎"
              class="name-text-field"
              :disabled="loading"
              @focus="focus"
              @blur="blur"
              tabindex="3"
            />
          </div>
          <div>
            <ErrorMessage name="lastName" v-slot="{ message }"
              ><p class="error">{{ message }}</p></ErrorMessage
            >
            <ErrorMessage name="firstName" v-slot="{ message }"
              ><p class="error">{{ message }}</p></ErrorMessage
            >
          </div>
          <label>生年月日</label>
          <div class="birth-area">
            <select
              v-model="birthYear"
              name="birthYear"
              class="number-field"
              :disabled="loading"
              placeholder="年"
              tabindex="4"
            >
              <option v-for="year in yearList" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
            <select
              v-model="birthMonth"
              name="birthMonth"
              class="number-field"
              :disabled="loading"
              tabindex="5"
            >
              <option v-for="month in monthList" :key="month" :value="month">
                {{ month }}
              </option>
            </select>
            <select
              v-model="birthDate"
              class="number-field"
              name="birthDate"
              :disabled="loading"
              tabindex="6"
            >
              <option
                v-for="date in changeDateList()"
                :key="date"
                :value="date"
              >
                {{ date }}
              </option>
            </select>
          </div>

          <div v-if="error" style="color: red">
            <p>{{ error }}</p>
          </div>
          <div>
            <label>メールアドレス</label>
            <div class="text-area">
              <Field
                type="text"
                v-model="mailAddress"
                name="mailAddress"
                placeholder="test@example.com"
                class="text-field"
                :disabled="loading"
                @focus="focus"
                @blur="blur"
              tabindex="7"
              />
              <div>
                <ErrorMessage name="mailAddress" v-slot="{ message }"
                  ><p class="error">{{ message }}</p></ErrorMessage
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-area">
        <common-button
          v-if="!isUser"
          :data="{
            status: !valid || loading ? 2 : 0,
            button: loading ? `登録中` : userInfoStore.isRegistFromProjectDetail ? `次へ` : `登録`,
          }"
          @click="valid && !loading ? onSubmit() : ''"
          :disabled="!valid || loading"
        ></common-button>
        <common-button
          v-else
          :data="{
            status: !valid || loading  ? 2 : 0,
            button: loading ? `更新中` : `更新`,
          }"
          @click="valid && !loading ? onSubmit() : ''"
          :disabled="!valid || loading"
        ></common-button>
      </div>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import router from "../router";

import { Field, Form, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";


import * as yup from "yup";
import liff from "@line/liff";
import { USER } from "../consts/common";

const yearNum: number = 100;
const yearList: number[] = [];
const monthList = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
let dateList: number[] = [];
const error = ref("");
const isUser = ref(false);
const updated = ref(false)

const userInfoStore = UserInfoStore();
const nickname = ref("");
const lastName = ref("");
const firstName = ref("");
const birthYear = ref(2000);
const birthMonth = ref(1);
const birthDate = ref(1);
const mailAddress = ref("");
const loading = ref(false);
const validationSchema = ref(
  yup.object().shape({
    nickname: yup
      .string()
      .trim()
      .required("ニックネームは必須です")
      .min(1)
      .label("ニックネーム"),
    lastName: yup.string().trim().required("姓は必須です").min(1).label("姓"),
    firstName: yup.string().trim().required("名は必須です").min(1).label("名"),
    mailAddress: yup
      .string()
      .required("メールアドレスは必須です")
      .email()
      .label("メールアドレス"),
  })
);
onMounted(() => {
  if (userInfoStore.userDetail.user_state == USER) {
    isUser.value = true;
    document.title = "プロフィール更新"
    // 登録済の情報を初期値で入れる
    setInitialData();
  } else {
    isUser.value = false;
    document.title = "プロフィール登録"
  }
  const year = new Date().getFullYear();
  for (let i: number = 0; i < yearNum; i++) {
    yearList.unshift(year - i);
  }
});

const changeDateList = () => {
  if (!birthYear.value || !birthMonth.value) {
    dateList.splice(0);
    return (dateList = [...Array(31)].map((_, i) => i + 1));
  } else {
    dateList.splice(0);
    dateList = [
      ...Array(new Date(birthYear.value, birthMonth.value, 0).getDate()),
    ].map((_, i) => i + 1);
    if (
      dateList[dateList.length - 1] < birthDate.value
    ) {
      birthDate.value = 1;
    }
    return dateList;
  }
};

function setInitialData() {
  // ユーザー情報未登録の場合は
  if (!userInfoStore.userDetail.name) return
  nickname.value = userInfoStore.userDetail.name;
  firstName.value = userInfoStore.userDetail.first_name;
  lastName.value = userInfoStore.userDetail.last_name;
  birthYear.value = userInfoStore.userDetail.birthday ? +userInfoStore.userDetail.birthday.substring(0, 4) : 2000;
  birthMonth.value = userInfoStore.userDetail.birthday ? +userInfoStore.userDetail.birthday.substring(5, 7) : 1;
  birthDate.value = userInfoStore.userDetail.birthday ? +userInfoStore.userDetail.birthday.substring(8, 10) : 1;
  mailAddress.value = userInfoStore.userDetail.email;
}


// 登録処理
const onSubmit = async () => {
  // 複数回リクエストが飛ばないようにする
  if (loading.value) return;
  loading.value = true;
  const birthDay =
    birthYear.value +
    "-" +
    String(birthMonth.value).padStart(2, "0") +
    "-" +
    String(birthDate.value).padStart(2, "0");
  const params = {
    name: nickname.value,
    first_name: firstName.value,
    last_name: lastName.value,
    birthday: birthDay,
    email: mailAddress.value,
    line_access_token: liff.getAccessToken(),
  };
  await userInfoStore
    .updateUserInfo(params)
    .then(async (v) => {
      loading.value = false;
      updated.value = true
      // state.value = 0
      if (v) {
        setTimeout(() => {
        if (userInfoStore.isRegistFromProjectDetail.show && !userInfoStore.bankInfo.id) {
        router.replace("/bank")
        } else if (userInfoStore.isRegistFromProjectDetail.show && (!userInfoStore.userSnsInfo.length || !userInfoStore.userSnsInfo.find((v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType))) {
          router.replace("/sns-accounts")
        }  else if (userInfoStore.isRegistFromProjectDetail.show && userInfoStore.addressInfo.id < 0) {
          router.replace("/address")
        } else {
        router.back()
        }
      },1000)
      }
    })
};
function focus() {
  const signup = document.getElementsByClassName(
    "signup"
  )[0] as HTMLElement;
  signup.style.overflowY = "visible"
}
function blur() {
  const signup = document.getElementsByClassName(
    "signup"
  )[0] as HTMLElement;
  signup.style.overflow= "hidden"
}
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";


.signup {
  width: 100%;
  max-width: 480px;
  height: 100%;
  max-height: 810px;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.signup::-webkit-scrollbar {
  display: none;
}
.header {
  text-align: center;
  width: 100%;
  padding-top: 10px;
}

label {
  font-size: $FONT_SIZE_M;
}
.form {
  width: 100%;
  max-width: 307px;
  margin: 0 auto;
  // font-family: $font-family-hiragino-gothic-pron;
  // text-align: center;
}
select {
  color: black;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("../assets/arrow.svg");
  background-repeat: no-repeat;
  background-size: 16px 13px;
  background-position: right 18px center;
}
.error {
  color: red;
  text-align: center;
  margin: 0;
}
.title {
  margin-top: 40px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_L;
  line-height: 24px;
  height: 60px;
  width: 100%;
  max-width: 480px;
  background-color: rgba(8, 110, 182, 0.04);
  > p {
    margin: 0;
    padding-top: 18px;
  }
}
.button-area {
  width: 100%;
  max-width: 317px;
  height: 56px;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
}
.loading {
  display: flex;
  position: absolute;
  justify-content: center;
  top: 50%;
  z-index: 9999;
  img {
    width: 10%;
    height: 10%;
  }
}
.birth-area {
  display: flex;
  width: 315px;
  justify-content: space-between;
  margin: 0 auto;
  padding-bottom: 16px;
  padding-top: 8px;
}
.number-field {
  width: 90px;
  height: 48px;
  border: 1px solid #777777;
  border-radius: 2px;
  background-color: $white;
  text-align: right;
  padding: 0 0 0 16px;
  font-size: $FONT_SIZE_M;
}
.name-area {
  display: flex;
  width: 315px;
  justify-content: space-between;
  margin: 0 auto;
  padding-bottom: 16px;
  padding-top: 8px;
}
.name-text-field {
  width: 142px;
  height: 48px;
  border-radius: 2px;
  border: 1px solid #777777;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.text-area {
  width: 307px;
  margin: 0 auto;
  padding-top: 8px;
}
.text-field {
  width: 307px;
  height: 48px;
  border: 1px solid #777777;
  border-radius: 2px;
  background-color: $white;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
</style>
